import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createBooking = (data) =>
  axios.post(`${API}/bookings`, data).then((r) => r.data);

export const createContact = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

export const adminLogin = (passcode) =>
  axios.post(`${API}/admin/login`, null, { params: { passcode } }).then((r) => r.data);

export const listBookings = (passcode) =>
  axios
    .get(`${API}/bookings`, { headers: { "X-Admin-Passcode": passcode } })
    .then((r) => r.data);

export const listContact = (passcode) =>
  axios
    .get(`${API}/contact`, { headers: { "X-Admin-Passcode": passcode } })
    .then((r) => r.data);

export const updateBookingStatus = (id, status, passcode) =>
  axios
    .patch(`${API}/bookings/${id}`, null, {
      params: { status },
      headers: { "X-Admin-Passcode": passcode },
    })
    .then((r) => r.data);
